import { createPayload } from '@/utils/createPayload';

// NOTE: 2026-05-06 Avoid usage of the createPayload mixin, it's here for backwards compatibility
// with .vue files that are still using mixins.
// We encourage you to use the createPayload util
export default {
    methods: {
        createPayload,
    },
};
